// Online rendelési időablak logika.
//
// A rendszer 19:00-kor (Budapest) vált a következő napra. Ettől a pillanattól
// lehet a következő napra online rendelést leadni, egészen az étterem adatlapján
// megadott "Online rendelés vége" időpontig (az adott napon).

export function budapestNowParts(): { date: string; minutes: number } {
  const now = new Date();
  const fmt = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Budapest",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  const parts = Object.fromEntries(fmt.formatToParts(now).map(p => [p.type, p.value]));
  const hour = parseInt(parts.hour === "24" ? "0" : parts.hour, 10);
  return {
    date: `${parts.year}-${parts.month}-${parts.day}`,
    minutes: hour * 60 + parseInt(parts.minute, 10),
  };
}

function toMinutes(time?: string | null): number | null {
  if (!time) return null;
  const m = /^(\d{1,2}):(\d{2})/.exec(time.trim());
  if (!m) return null;
  return parseInt(m[1], 10) * 60 + parseInt(m[2], 10);
}

export function formatDateKey(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/**
 * Leadható-e most online rendelés a megjelenített menü napjára?
 * - Csak az aktuális "logikai napra" (19:00 utáni váltás után a következő napra).
 * - Az adott napon az "Online rendelés vége" időpontig.
 */
export function isOnlineOrderingOpen(menuDate: Date | undefined, endTime?: string | null): boolean {
  if (!menuDate) return true;
  const { date: todayKey, minutes: nowMinutes } = budapestNowParts();
  const menuKey = formatDateKey(menuDate);

  // Múltbeli nap: zárva
  if (menuKey < todayKey) return false;

  const end = toMinutes(endTime);

  // Mai napra: csak a rendelési határidő előtt
  if (menuKey === todayKey) {
    if (end == null) return true;
    return nowMinutes < end;
  }

  // Következő nap: 19:00-tól nyit
  const tomorrow = new Date(`${todayKey}T00:00:00`);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (menuKey === formatDateKey(tomorrow)) {
    return nowMinutes >= 19 * 60;
  }

  // Távolabbi napok: még nem rendelhető
  return false;
}
